import { render, staticRenderFns } from "./customerOverviewTab.vue?vue&type=template&id=49133811&scoped=true"
import script from "./customerOverviewTab.vue?vue&type=script&lang=js"
export * from "./customerOverviewTab.vue?vue&type=script&lang=js"
import style0 from "./customerOverviewTab.vue?vue&type=style&index=0&id=49133811&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49133811",
  null
  
)

export default component.exports